var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / EG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-EG",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#E41D33",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#262626",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,8.33333333 C14.5555556,8.33333333 15.0351909,9.48240453 15.0351909,9.48240453 C15.0351909,9.48240453 15.1890333,9.85096757 15.2514912,10.2423736 L15.2514912,10.2423736 L16.0856545,8.57404702 C16.6290427,8.41093063 16.8165539,8.34598914 16.9022317,8.43087678 C16.9619847,8.49007881 17,8.57134786 17,8.66051865 L17,8.66051865 L17,10.875656 L15.3878988,10.3333333 L14.3333333,10.3333333 L14.3333333,11.1777058 L14.3333333,11.1777058 L14.1759158,11.3175831 C13.9926397,11.4807587 13.8205833,11.6262846 13.7636695,11.5693708 C13.7034899,11.5091912 13.6666667,11.4258209 13.6666667,11.3333333 L13.6666667,11.3333333 L13.6666667,10.3333333 L12.5657415,10.3333333 L11.4495493,11.0774614 L11.0009562,8.63536268 C11.007075,8.55519641 11.0422088,8.48312532 11.0962015,8.4296306 C11.4637353,8.33333333 11.5703903,8.34201766 11.6569064,8.35971073 L11.6569064,8.35971073 L12.7121354,10.0291323 C12.8313291,9.72704511 12.9588212,9.49382275 12.9588212,9.49382275 C12.9588212,9.49382275 13.2582307,8.94611048 13.6229599,8.58138127 C13.744507,8.45983417 13.8693648,8.33333333 14,8.33333333 Z",
    id: "Rectangle-129",
    stroke: "#C6A846",
    strokeWidth: 0.666666667,
    fillOpacity: 0.25,
    fill: "#F4B32E",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEg);
export default __webpack_public_path__ + "static/media/EG.f0a412a30121f794cbc98da70e82d10a.svg";
export { ForwardRef as ReactComponent };